const url = 'situacoes-propostas';
class SituacaoPropostaService {
    async list(params) {
        const response = await window.$http.get(`${url}/find-list`, params);
        return response.data;
    }
}

export default new SituacaoPropostaService();
